// Generated by ReScript, PLEASE EDIT WITH CARE


function t(titleColorOpt, descriptionColorOpt, param) {
  var titleColor = titleColorOpt !== undefined ? titleColorOpt : ({
        NAME: "hex",
        VAL: "313E49"
      });
  var descriptionColor = descriptionColorOpt !== undefined ? descriptionColorOpt : ({
        NAME: "hex",
        VAL: "4B4B4B"
      });
  return {
          titleColor: titleColor,
          descriptionColor: descriptionColor
        };
}

export {
  t ,
}
/* No side effect */
